<template>
  <div class="root-grid">
      <header>
        <div>
          <div class="square"></div> <span> Still not lived </span>
        </div>
        <div>
          <div class="square lived"></div><span> Lived </span>
        </div>
        <div>
          <div class="square important-event"></div> <span> Important events </span>
        </div>
      </header>
      <div class="squares-container" >
          <template v-for="index in squareNumber[selectedTime]">
            <div class="square-container" v-bind:key="index" >
              <template v-if="isImportantEvent(index)">
                <div 
                  class="square important-event" 
                  v-bind:class="{'lived':(index < livedTill),}" 
                  v-tippy
                  :content="getDecriptionByIndex(index)"
                />
              </template>
              <div v-else class="square" v-bind:class="{'lived':(index < livedTill)}" ></div>
            </div>
          </template>
      </div>
  </div>  
</template>

<script>
import { DateTime } from "luxon";
export default {
    props: ['birthdate', 'selectedTime'],
    name: "CalendarGrid",
    data() {
      return {
        squareNumber: {
          'weeks':4692,
          'months':1080,
          'years':90
        },
        importantEvents: [ 
          {
            "weeks":782,
            "months":180,
            "years":15,
            "description":"<b>First kiss (15 years)</b></br>"
          },
          {
            "weeks":902,
            "months":208,
            "years":17,
            "description":"<b>First time (17.3 years)</b></br>"
          },
          {
            "weeks":991,
            "months":228,
            "years":19,
            "description":"<b>First full time job(19 years)</b></br>"
          },
          {
            "weeks":1043,
            "months":240,
            "years":20,
            "description":"<b>Pass driving test(20 years)</b></br>"
          },
          {
            "weeks":1095,
            "months":252,
            "years":21,
            "description":"<b>First holiday with friends(21 years)</b></br>"
          },
          {
            "weeks":1147,
            "months":264,
            "years":22,
            "description":"<b>Buy first car (and move out)(22 years)</b></br>"
          },
          {
            "weeks":1199,
            "months":276,
            "years":23,
            "description":"<b>First holiday with partner (and be a bridesmaid or best man)(23 years)</b></br>"
          },
          {
            "weeks":1251,
            "months":288,
            "years":24,
            "description":"<b>Rent on your own(24 years)</b></br>"
          },
          {
            "weeks":1303,
            "months":300,
            "years":25,
            "description":"<b>Get engaged (and rent with partner)(25 years)</b></br>"
          },
          {
            "weeks":1408,
            "months":324,
            "years":27,
            "description":"<b>Get married (and buy your first flat)(27 years)</b></br>"
          },
          {
            "weeks":1460,
            "months":336,
            "years":28,
            "description":"<b>Have first Child(28 years)</b></br>"
          },
          {
            "weeks":1512,
            "months":348,
            "years":29,
            "description":"<b>Buy first house(29 years)</b></br>"
          },
          {
            "weeks":1564,
            "months":360,
            "years":30,
            "description":"<b>Start earning average wage(30 years)</b></br>"
          },
          {
            "weeks":1668,
            "months":384,
            "years":32,
            "description":"<b>Buy a brand new car(32 years)</b></br>"
          },
          {
            "weeks":1773,
            "months":408,
            "years":34,
            "description":"<b>Become a manager at work(32 years)</b></br>"
          },
          {
            "weeks":1825,
            "months":420,
            "years":35,
            "description":"<b>Think about starting a business(35 years)</b></br>"
          },
          {
            "weeks":1877,
            "months":432,
            "years":36,
            "description":"<b>Move to a second house(36 years)</b></br>"
          },
          {
            "weeks":1929,
            "months":444,
            "years":37,
            "description":"<b>Start earning 40k a year(37 years)</b></br>"
          },
          {
            "weeks":3129,
            "months":720,
            "years":60,
            "description":"<b>Retire(60 years)</b></br>"
          },
          {
            "weeks":3754,
            "months":864,
            "years":72,
            "description":"<b>Die(72 years)</b></br>"
          },
          
        ],
        importantIndexes: [],
      }
    },
    methods: {
      getPlusObject: function(index){
        switch(this.selectedTime){
          case 'weeks':return { weeks:index }
          case 'months': return {months:index}
          case 'years': return {years:index} 
          default: return {years:index}
        }
      },
      getDecriptionByIndex: function(index){
        if(this.birthdate){
          return `${DateTime.fromJSDate(this.birthdate).
            plus(
              this.getPlusObject(index)
            )
            .toLocaleString()}</br>${this.importantEvents.filter( event => event[this.selectedTime] === index)[0].description}`;
        }
        return this.importantEvents.filter( event => event[this.selectedTime] === index)[0].description;
      },
      isImportantEvent: function(index){
        return this.importantEvents.some( e => e[this.selectedTime] === index )  
      },
    },
    computed: {
      livedTill: function () {
        return DateTime.local().diff(DateTime.fromJSDate(this.birthdate), this.selectedTime)[this.selectedTime];
      }
    },
}
</script>
<style scoped>
.root-grid header{
  width: 80%;
  max-width: 1104px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #3d3d3d;
  font-size: 0.9rem;
  padding: 1rem 0 .1rem 0;
  flex-wrap: wrap;
}
.root-grid header .square{
  display: inline-block;
}
.root-grid header > div{
  padding: .3rem 2rem .3rem 0;
}

.settings {
  margin: 2em 0;
  border-top: 1px solid #bbb;
  background: #eee;
}

.squares-container{
    display: flex;
    width: 80%;
    max-width: 1104px;
    flex-wrap: wrap;
    padding: 0;
}
.square-container{
  /* width: 8px;
  height: 8px;
  margin: 2px; */
  box-sizing: border-box;
  position: relative;
}

.square{
    font-size: 10px;
    background: #e2e2e2;
    margin: 1px;
    width: 0.5rem;
    height: 0.5rem;
    padding: 1px;
    /* display: absolute; */
    cursor: pointer;
    /* border: solid 1px #e2e2e2; */
    z-index: 1;
}
@media only screen and (max-width: 600px){
  .square{
    height: 5px;
    width: 5px;
  }
  .squares-container{
    display: flex;
    width: 90%;
  }
  
  .root-grid header{
    width: 90%;
    justify-content: center;
  }
}
.lived{
  background: #ffb2ac;
}
.important-event{
  background: #88bafd;
}

</style>